import { Link } from "react-router-dom";
import { FetchURL } from "../utils/url"
import useFetch from "../utils/useFetch"
import Loading from "../components/Loading";

const Category = () => {
    const { data, loading} = useFetch(FetchURL)

    const products = data.products;
    const category = [...new Set(products?.map((product)=>product.category))]

    if(loading) return <Loading />

    
    return(
    <div className="relative overflow-hidden px-6 py-32 md:px-12 lg:px-20">
        <div className="max-w-5xl mx-auto">
            <div className="max-w-7xl mx-auto grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3  gap-3 sm:gap-5 not-prose">
                {category && category.map((item)=>(
                <Link to={`/category/${item}`} key={item}
                    className="relative flex flex-col items-start justify-between p-6 overflow-hidden rounded-xl border border-gray-200 dark:border-gray-800 dark:bg-black bg-white group">
                    <span className="absolute w-full h-full bg-white dark:bg-black inset-0 dark:group-hover:bg-gray-900 group-hover:bg-gray-50 group-hover:bg-opacity-30"></span>
                    <div className="flex items-center justify-between w-full mb-4 ">
                        <span className="opacity-0 -translate-x-2 flex-shrink-0 group-hover:translate-x-0 py-1 px-2.5 text-[0.6rem] group-hover:opacity-100 transition-all ease-out duration-200 rounded-full bg-indigo-50 dark:bg-indigo-500 dark:text-white text-indigo-500 flex items-center justify-center">
                            <span>View Products</span>
                        
                        </span>
                    </div>
                    <span className="relative text-md md:text-lg text-gray-600 dark:text-gray-400">{item}</span>
                </Link>
                ))}
            </div>
        </div>
    </div>
    )
}

export default Category